import { useRef } from 'react';
import styles from './line-spinner.module.css';
import { useInView } from '~/shared/hooks/useInView/useInView';
import clsx from 'clsx';

type Props = {
    inView?: boolean;
    delay?: number | undefined;
    shade?: 'light' | 'dark' | undefined;
    width?: string | number | undefined;
    positionAbsolute?: boolean;
};

export const LineSpinner = ({
    inView = false,
    delay = 0,
    shade = 'dark',
    width = 50,
    positionAbsolute = false,
}: Props) => {
    const ref = useRef<HTMLDivElement | null>(null);

    const isInView = useInView(ref, {
        threshold: 1,
        rootMargin: '100px 0px',
        once: true,
    });

    return (
        <span
            className={clsx(styles.root, [styles[`${shade}Shade`]], {
                [styles.animate]: inView ? isInView : true,
                [styles.positionAbsolute]: positionAbsolute,
            })}
            ref={inView ? ref : null}
            style={
                {
                    width: width,
                    '--delay': `${delay}s`,
                } as React.CSSProperties
            }
        />
    );
};
